export default "__VITE_ASSET__CGvRbv3I__"